export { default } from '@shikijs/langs/mdx'
